module.exports = __webpack_public_path__ + "img/PWarWagon64_ua.926f5fad.webp";